import A11yDialog from "a11y-dialog";
import { getElement, getElements, ifSelectorExist } from "./utils";

export const videoDialogWindow = () => {
  const dialogContainer = document.querySelector("#videoDialog");
  if (ifSelectorExist(dialogContainer)) {
    const videoReviewsDialog = new A11yDialog(dialogContainer);

    let fireTestimonialModalSelector = getElements(".fireTestimonialModal");
    if (ifSelectorExist(fireTestimonialModalSelector)) {
      Array.from(fireTestimonialModalSelector).forEach((item) => {
        item.addEventListener("click", () => {
          let testimonialVideoIdSelector = getElement(
            "#testimonialVideoIdSelector"
          );
          if (ifSelectorExist(testimonialVideoIdSelector)) {
            let itemYtUrl = item.getAttribute("data-yt-url");
            testimonialVideoIdSelector.src = itemYtUrl;
          }
        });
      });
    }

    videoReviewsDialog.on("hide", function (dialogEl, event) {
      dialogEl.querySelector("iframe").contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    });

    videoReviewsDialog.on("show", function (dialogEl, event) {
      dialogEl.querySelector("iframe").onload = () => {
        dialogEl.querySelector("iframe").contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
      };
    });

  }
};

export const formDialogBottomNav = () => {
  let bottomNavTrigger = getElement("#formDialog");
  const dialog = new A11yDialog(bottomNavTrigger);

  let triggerSelector = getElements('[data-a11y-dialog-show]');
  Array.from(triggerSelector).forEach(element => {
    bodySelector = getElement('html');

    element.addEventListener('click', () => {


    })
  });


  dialog
    .on('show', () => (
      document.documentElement.style.overflowY = 'hidden'))
    .on('hide', () => (document.documentElement.style.overflowY = ''))

};



export const formDialogSingleAttorney = () => {
  let attorneySingleModal = getElement("#attorneyDialog");
  const dialog = new A11yDialog(attorneySingleModal);

  let triggerSelector = getElements('[data-a11y-dialog-show]');
  Array.from(triggerSelector).forEach(element => {
    bodySelector = getElement('html');

    element.addEventListener('click', () => {


    })
  });


  dialog
    .on('show', () => (
      document.documentElement.style.overflowY = 'hidden'))
    .on('hide', () => (document.documentElement.style.overflowY = ''))

};


export const formDialogCtaSidebar = () => {
  let attorneySingleModal = getElement("#dialogCtaSidebar");
  const dialog = new A11yDialog(attorneySingleModal);

  let triggerSelector = getElements('[data-a11y-dialog-show]');
  Array.from(triggerSelector).forEach(element => {
    bodySelector = getElement('html');

    element.addEventListener('click', () => {
    })
  });


  dialog
    .on('show', () => (
      document.documentElement.style.overflowY = 'hidden'))
    .on('hide', () => (document.documentElement.style.overflowY = ''))

};